import type { ImageAOI } from '@core/models/imageAssets';
import dayjs from '@utils/dateUtils';

const UNAVAILABLE_SENTINEL_DATES = ['2026-10-20', '2026-10-21'] as const;

export type UnavailableSentinelImageDate = typeof UNAVAILABLE_SENTINEL_DATES[number];

export const getUnavailableSentinelImageDate = (
  image: Pick<ImageAOI, 'id' | 'acquiredAt'>
): UnavailableSentinelImageDate | undefined => {
  if (!image.id.includes('_s2b_')) return undefined;

  const date = dayjs.utc(image.acquiredAt).format('YYYY-MM-DD');
  return UNAVAILABLE_SENTINEL_DATES.find((unavailableDate) => unavailableDate === date);
};

export const isUnavailableSentinelImage = (image: Pick<ImageAOI, 'id' | 'acquiredAt'>): boolean =>
  getUnavailableSentinelImageDate(image) !== undefined;
